import { L } from '@angular/cdk/keycodes';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private _currentLanguage = new BehaviorSubject<Language>(Language.SV);
  public currentLanguage$ = this._currentLanguage.asObservable();
  public db = LanguageDatabase;

  constructor() { }

  public get currentLanguage(): Language {
    return this._currentLanguage.value;
  }

  public setLanguage(lang: Language) {
    this._currentLanguage.next(lang);
  
  }

  public GetValue(id: string): string {
    const entry = LanguageDatabase[id];

    if (!entry) return `Hittade inte översättning för: ${id}`;

    if (environment.application === 'NjdbPåWebb') {
      return entry.swedish;
    } else if (environment.application === 'JNBKarta') {
      if (this.currentLanguage === Language.SV) {
        return entry.swedish;
      } else if (this.currentLanguage === Language.ENG) {
        return entry.english;
      }
    }
    return `Hittade inte översättning för: ${id}`;
  }
}

export var LanguageDatabase: { [id: string]: LanguageObject } = {};


/******************REPEATED******************/
LanguageDatabase["MapMenu.Close"] = { swedish: "Stäng", english: "Close" }
LanguageDatabase["MapMenu.Selected"] = { swedish: "Visa valda", english: "Selected" }
LanguageDatabase["MapMenu.Required"] = { swedish: "Måste anges.", english: "Required." }

/******************SIDEBAR******************/

LanguageDatabase["MapMenu.Map"] = { swedish: "JNB Karta", english: "JNB Map" }
LanguageDatabase["MapMenu.Legend"] = { swedish: "Teckenförklaring", english: "Legend" }

/*Searchmenu*/
LanguageDatabase["Searchmenu.Search"] = { swedish: "Sök", english: "Search" }
LanguageDatabase["Searchmenu.SearchFor"] = { swedish: "Sök efter", english: "Search for" }
LanguageDatabase["Searchmenu.Place"] = { swedish: "Plats", english: "Place" }
LanguageDatabase["Searchmenu.Coor"] = { swedish: "Koordinat", english: "Coordinate" }
LanguageDatabase["Searchmenu.PlaceCoor"] = { swedish: "Plats, koordinat", english: "Place, coordinate" }
LanguageDatabase["Searchmenu.PlaceCoorSwe"] = { swedish: "Plats, koordinat (Sweref99TM, WGS 84)", english: "Place, coordinate (Sweref99TM, WGS 84)" }
LanguageDatabase["Searchmenu.RailwaySection"] = { swedish: "Bandel", english: "Railway section" }
LanguageDatabase["Searchmenu.Street"] = { swedish: "Gatunamn", english: "Street name" }
LanguageDatabase["Searchmenu.Route"] = { swedish: "Stråk", english: "Route" }
LanguageDatabase["Searchmenu.OperationalPoint"] = { swedish: "Trafikplats", english: "Operational point" }
LanguageDatabase["Searchmenu.Filter"] = { swedish: "Filtrera..", english: "Filter.." }
LanguageDatabase["Searchmenu.Municipalities"] = { swedish: "Kommuner", english: "Municipalities" }
LanguageDatabase["Searchmenu.Place"] = { swedish: "Orter", english: "Place" }
LanguageDatabase["Searchmenu.UrbanAreas"] = { swedish: "Tätorter", english: "Urban areas" }
LanguageDatabase["Searchmenu.SearchErr"] = { swedish: "Sökordet måste innehålla minst 2 tecken", english: "The search term must contain at least 2 characters" }
LanguageDatabase["Searchmenu.Result"] = { swedish: "resultat", english: "result" }
LanguageDatabase["Searchmenu.Results"] = { swedish: "resultat", english: "results" }
LanguageDatabase["Searchmenu.NoResults"] = { swedish: "Inga träffar på", english: "No results for" }



/*Layerlist Dataproducts*/
LanguageDatabase["Layerlist.DataProducts"] = { swedish: "Lagerlista", english: "Layer list" }
LanguageDatabase["Layerlist.Layerlist"] = { swedish: "Lagerlista", english: "Layer list" }
LanguageDatabase["Layerlist.JNB"] = { swedish: "Järnvägsnätsbeskrivning", english: "Railway network statement" }
LanguageDatabase["Layerlist.Edition"] = { swedish: "Utgåva", english: "Edition" }
LanguageDatabase["Layerlist.SearchLayer"] = { swedish: "Sök lager", english: "Search layer" }
LanguageDatabase["Layerlist.ShowChoosen"] = { swedish: "dataprodukt vald", english: "data product selected" }
LanguageDatabase["Layerlist.ShowChoosenPlural"] = { swedish: "dataprodukter valda", english: "data products selected" }
LanguageDatabase["Layerlist.Descrip"] = { swedish: "Beskrivning:", english: "Description:" }
LanguageDatabase["Layerlist.LacksDescrip"] = { swedish: "Lagret saknar beskrivning.", english: "The layer lacks a description." }
LanguageDatabase["Layerlist.VisibleScale"] = { swedish: "Lagret synligt från skala:", english: "Layer visible from scale:" }
LanguageDatabase["Layerlist.Legend"] = { swedish: "Teckenförklaring:", english: "Legend:" }
LanguageDatabase["Layerlist.Opacity"] = { swedish: "Sätt opacitet:", english: "Set opacity:" }
LanguageDatabase["Layerlist.TopLayer"] = { swedish: "Flytta lager till toppen", english: "Move layer to top" }
LanguageDatabase["Layerlist.NoProductsFound"] = { swedish: "Inga dataprodukter hittades.", english: "No data products found." }
LanguageDatabase["Layerlist.ChangesJNB"] = { swedish: "Ändringar syns inte i JNB förrän nästa dag", english: "Changes in JNB will not be visible until the next day" }

/*Backgroundlist*/
LanguageDatabase["BackgroundList.Layer"] = { swedish: "Bakgrundslager", english: "Background layers" }
LanguageDatabase["BackgroundList.Map"] = { swedish: "Bakgrundskarta", english: "Background map" }
// översätt bakgrundskatorna, här eller i lagerlistan?

/*Saved views*/
LanguageDatabase["SavedViews.SavedViews"] = { swedish: "Sparade vyer", english: "Saved views" }
LanguageDatabase["SavedViews.SortNewestFirst"] = { swedish: "Sortera nyaste först", english: "Sort newest first" }
LanguageDatabase["SavedViews.SortOldestFirst"] = { swedish: "Sortera äldsta först", english: "Sort oldest first" }
LanguageDatabase["SavedViews.SortAZ"] = { swedish: "Sortera A-Z", english: "Sort A-Z" }
LanguageDatabase["SavedViews.SortZA"] = { swedish: "Sortera Z-A", english: "Sort Z-A" }
LanguageDatabase["SavedViews.SaveView"] = { swedish: "Spara vy", english: "Save view" }
LanguageDatabase["SavedViews.Sweden"] = { swedish: "Sverige", english: "Sweden" }
LanguageDatabase["SavedViews.SavedInfo"] = { swedish: "Sparar zoomläge, kartinställningar, och valda dataprodukter.", english: "Saves zoom level, map settings, and selected data products." }
LanguageDatabase["SavedViews.CreateView"] = { swedish: "Skapa vy", english: "Create view" }
LanguageDatabase["SavedViews.UpdateView"] = { swedish: "Uppdatera vy", english: "Update view" }
LanguageDatabase["SavedViews.Name"] = { swedish: "Namn:", english: "Name:" }
LanguageDatabase["SavedViews.ViewName"] = { swedish: "Vynamn", english: "View name" }
LanguageDatabase["SavedViews.MaxChar"] = { swedish: "Max 30 tecken.", english: "Max 30 characters" }
LanguageDatabase["SavedViews.NameAlreadyExists"] = { swedish: "Namnet är redan taget.", english: "The name is already taken" }
LanguageDatabase["SavedViews.Layer"] = { swedish: "Lager:", english: "Layer:" }
LanguageDatabase["SavedViews.SaveCurrentBackground"] = { swedish: "Spara nuvarande bakgrundsbild", english: "Save current background image" }
LanguageDatabase["SavedViews.SaveCurrentLayer"] = { swedish: "Spara nuvarande datalager", english: "Save current data layer" }
LanguageDatabase["SavedViews.CorrErr"] = { swedish: "Var vänlig och korrigera felen, det gick ej att spara vyn. ", english: "Please correct the errors, the view could not be saved." }
LanguageDatabase["SavedViews.GoToView"] = { swedish: "Gå till vy", english: "Go to view" }
LanguageDatabase["SavedViews.Edit"] = { swedish: "Redigera", english: "Edit" }
LanguageDatabase["SavedViews.Delete"] = { swedish: "Ta bort", english: "Delete" }
LanguageDatabase["SavedViews.DeleteView"] = { swedish: "Radera vy", english: "Delete view" }
LanguageDatabase["SavedViews.Confirm"] = { swedish: "Bekräfta borttagning av vy", english: "Confirm deletion of view" }
LanguageDatabase["SavedViews.DeleteConfirmation"] = { swedish: "Är du säker på att du vill ta bort vyn", english: "Are you sure you want to delete the view" }
LanguageDatabase["SavedViews.DeleteViewConfirm"] = { swedish: "Ta bort vy", english: "Delete view" }
LanguageDatabase["SavedViews.KeepViewConfirm"] = { swedish: "Behåll vy", english: "Keep view" }
LanguageDatabase["SavedViews.Cancel"] = { swedish: "Avbryt", english: "Cancel" }
LanguageDatabase["SavedViews.UpdatedView"] = { swedish: "Du uppdaterade vyn.", english: "Updated favorite view." }
LanguageDatabase["SavedViews.AddViewView"] = { swedish: "Vyn har lagts till.", english: "The view" }
LanguageDatabase["SavedViews.AddViewAdded"] = { swedish: " har lagts till.", english: "has been added." }
LanguageDatabase["SavedViews.RemovedView"] = { swedish: "Vyn togs bort.", english: "The view was removed." }
LanguageDatabase["SavedViews.UpdatedView"] = { swedish: "Vyn uppdaterades.", english: "The view was updated." }
LanguageDatabase["SavedViews.UpdatedFavoriteView"] = { swedish: "Uppdaterade favoritvy.", english: "Updated favorite view." }
LanguageDatabase["SavedViews.SetFavorite"] = { swedish: "Sätt vy som favorit", english: "Set view as favorite" }
LanguageDatabase["SavedViews.View"] = { swedish: "Vyn", english: "View" }
LanguageDatabase["SavedViews.removed"] = { swedish: "togs bort", english: "was removed" }



/*Share map*/
LanguageDatabase["ShareMap.ShareMap"] = { swedish: "Dela karta", english: "Share map" }
LanguageDatabase["ShareMap.IncludeMap"] = { swedish: "Inkludera bakgrundskarta", english: "Include background map" }
LanguageDatabase["ShareMap.IncludeLayer"] = { swedish: "Inkludera lager", english: "Include layer" }
LanguageDatabase["ShareMap.Copy"] = { swedish: "Kopiera länk till nuvarande kartvy", english: "Copy link to current map view" }
LanguageDatabase["ShareMap.Copied"] = { swedish: "Kopierade länken", english: "Copied the link" }
LanguageDatabase["ShareMap.CopyErr"] = { swedish: "Kunde inte kopiera länken", english: "Could not copy the link" }
LanguageDatabase["ShareMap.LinkCurrent"] = { swedish: "Länk till nuvarande kartvy", english: "Link to current map view" }
LanguageDatabase["ShareMap.TxtInfo"] = {
  swedish: "Här kan man kopiera länken till kartvyn med bakgrundskarta och tända lager till t.ex. ett mail och dela kartan med andra.",
  english: "Here you can copy the link to the map view, including the background map and active layers, to share it with others."
}


/***Infoclick menu***/
LanguageDatabase["InfoClick.InfoClick"] = { swedish: "Infoklick", english: "Infoclick" }
LanguageDatabase["InfoClick.ZoomTo"] = { swedish: "Zooma till position", english: "Zoom to position" }
LanguageDatabase["InfoClick.TxtInfo"] = {
  swedish: "Klicka på en företeelse i kartan från en tänd dataprodukt för att visa information om den. Om ingen dataprodukt är tänd kan du istället klicka på en väglänk för att få information om den.",
  english: "Click on a feature in the map from an enabled data product to display information about it. If no data product is enabled, you can instead click on a road link to get information about it."
}
LanguageDatabase["InfoClick.NoInfo"] = { swedish: "Ingen information finns i vald position.", english: "No information is available at the selected position." }
LanguageDatabase["InfoClick.CancelSearch"] = { swedish: "Avbryt sökning", english: "Cancel search" }
LanguageDatabase["InfoClick.Dataproduct"] = { swedish: "Lager:", english: "Layer:" }
LanguageDatabase["InfoClick.Hits"] = { swedish: "Antal träffar:", english: "Number of hits:" }
LanguageDatabase["InfoClick.ShowInfo"] = { swedish: "Visa information om dataprodukten", english: "Show information about the data product" }



// ska översättning av infoklicksdata ligga här eller i datalagret?

/***Print menu***/
LanguageDatabase["PrintMenu.Print"] = { swedish: "Utskrift", english: "Print" }
LanguageDatabase["PrintMenu.Save"] = { swedish: "Spara som", english: "Save as" }
LanguageDatabase["PrintMenu.Legend"] = { swedish: "Teckenförklaring", english: "Legend" }
LanguageDatabase["PrintMenu.ShowLegend"] = { swedish: "Visa teckenförklaring", english: "Show legend" }
LanguageDatabase["PrintMenu.NorthArrow"] = { swedish: "Norrpil", english: "North arrow" }
LanguageDatabase["PrintMenu.ScaleBar"] = { swedish: "Skalstock", english: "Scale bar" }
LanguageDatabase["PrintMenu.ShowNorthArrow"] = { swedish: "Visa norrpil", english: "Show north arrow" }
LanguageDatabase["PrintMenu.ShowScale"] = { swedish: "Visa skalstock", english: "Show scale bar" }
LanguageDatabase["PrintMenu.PageOriention"] = { swedish: "Sidorientering", english: "Page orientation" }
LanguageDatabase["PrintMenu.Portrait"] = { swedish: "Stående", english: "Portrait" }
LanguageDatabase["PrintMenu.Landscape"] = { swedish: "Liggande", english: "Landscape" }
LanguageDatabase["PrintMenu.PageSize"] = { swedish: "Sidstorlek", english: "Page size" }
LanguageDatabase["PrintMenu.All"] = { swedish: "Hela", english: "All" }
LanguageDatabase["PrintMenu.Export"] = { swedish: "Exportera", english: "Export" }
LanguageDatabase["PrintMenu.FileExp"] = { swedish: "Din fil exporteras.", english: "Your file is being exported." }
LanguageDatabase["PrintMenu.PleaseWait"] = { swedish: "Vänligen vänta.", english: "Please wait." }
LanguageDatabase["PrintMenu.PreExp"] = { swedish: "Förhandsgranskning export", english: "Preview export" }
LanguageDatabase["PrintMenu.Download"] = { swedish: "Laddda ner", english: "Download" }
LanguageDatabase["PrintMenu.ExpError"] = { swedish: "Kunde inte skapa PDF", english: "Could not create PDF" }
LanguageDatabase["PrintMenu.PdfCreated"] = { swedish: "PDF skapad", english: "PDF created" }
LanguageDatabase["PrintMenu.ExpComp"] = { swedish: "Exporten klar.", english: "Export completed." }
LanguageDatabase["PrintMenu.Center"] = { swedish: "Centrera", english: "Center" }
LanguageDatabase["PrintMenu.CenterExp"] = { swedish: "Centrera exportarea", english: "Center export area" }
LanguageDatabase["PrintMenu.ZoomTo"] = { swedish: "Zooma till", english: "Zoom to" }
LanguageDatabase["PrintMenu.ZoomToExp"] = { swedish: "Zooma till exportarea", english: "Zoom to export area" }
LanguageDatabase["PrintMenu.ExportArea"] = { swedish: "Exportarea (skala)", english: "Export area (scale)" }



/******************HEADER******************/

/***Language***/
LanguageDatabase["Lang.Change"] = { swedish: "Ändra språk", english: "Change language" }
LanguageDatabase["Lang.Sv"] = { swedish: "Svenska", english: "Swedish" }

/***Info***/
LanguageDatabase["InfoMenu.About"] = { swedish: "Om", english: "About" }
LanguageDatabase["InfoMenu.TxtHeadlineFirst"] = { swedish: "Här kan du betrakta JNB - Sveriges järnvägsnätsbeskrivning", english: "Here you can view JNB - Sweden's railway network description" }
LanguageDatabase["InfoMenu.TxtInfoFirst"] = {
  swedish: "JNB karta presenterar tillgänglig infrastruktur på Trafikverkets järnvägsnät. JNB karta publiceras årligen i samband med varje publicerad JNB. Kartjänsten uppdateras vid behov och viktiga förändringar av data kommer att publiceras i nyhetsflödet på JNB hemsidan. Informationen presenteras både på svenska och engelska.",
  english: "JNB map presents available infrastructure on the Swedish Transport Administration's railway network. JNB map is published annually in connection with each published JNB. The map service is updated as needed and important changes to data will be published in the news feed on the JNB website. The information is presented in both Swedish and English."
}
LanguageDatabase["InfoMenu.TxtInfoSecondFirst"] = { swedish: "Ändringar i JNB syns inte i", english: "Changes in JNB will not be visible in" }
LanguageDatabase["InfoMenu.TxtInfoSecondLast"] = { swedish: "förrän nästa dag", english: "until the next day" }
LanguageDatabase["InfoMenu.TxtHeadlineSecond"] = { swedish: "Mer om järnvägsnätsbeskrivningen", english: "More about the railway network statement" }
LanguageDatabase["InfoMenu.DescLink"] = { swedish: "JNB - Järnvägsnätsbeskrivning", english: "JNB - Railway Network Statement" }
LanguageDatabase["InfoMenu.TxtHeadlineThird"] = { swedish: "Användarhandledning", english: "User manual" }
LanguageDatabase["InfoMenu.Questions"] = { swedish: "Vid frågor eller synpunkter", english: "Questions or comments" }


/******************TOOLS******************/
LanguageDatabase["ToolsMenu.Pan"] = { swedish: "Panorera genom att dra i kartan", english: "Panorama by dragging the map" }
LanguageDatabase["ToolsMenu.ZoomRec"] = { swedish: "Zooma med rektangel", english: "Zoom with rectangle" }
LanguageDatabase["ToolsMenu.ViewSwe"] = { swedish: "Visa hela Sverige", english: "View all of Sweden" }
LanguageDatabase["ToolsMenu.Measure"] = { swedish: "Mät i kartan", english: "Measure on map" }
LanguageDatabase["ToolsMenu.ShowCoor"] = { swedish: "Visa koordinat i karta", english: "Show coordinate on map" }
LanguageDatabase["ToolsMenu.ClearMap"] = { swedish: "Rensa i  kartan", english: "Clear map" }
LanguageDatabase["ToolsMenu.PrintForm"] = { swedish: "Utskriftsformat", english: "Print format" }
LanguageDatabase["ToolsMenu.InfoClick"] = { swedish: "Klicka på dataprodukt i karta för mer information om de företeelser som finns på den positionen", english: "Click on a data product in the map for more information about the features that are at that position" }
LanguageDatabase["ToolsMenu.Position"] = { swedish: "Gå till din position", english: "Go to your position" }
LanguageDatabase["ToolsMenu.ZoomIn"] = { swedish: "Zooma in", english: "Zoom in" }
LanguageDatabase["ToolsMenu.ZoomOut"] = { swedish: "Zooma ut", english: "Zoom out" }
LanguageDatabase["ToolsMenu.PreView"] = { swedish: "Gå till föregående vy", english: "Go to previous view" }
LanguageDatabase["ToolsMenu.NextView"] = { swedish: "Gå till nästa vy", english: "Go to next view" }
LanguageDatabase["ToolsMenu.LengthTool"] = { swedish: "Längdverktyg", english: "Length tool" }
LanguageDatabase["ToolsMenu.LengthSection"] = { swedish: "Längd delsträcka", english: "Length sub-section" }
LanguageDatabase["ToolsMenu.TotalLength"] = { swedish: "Total längd", english: "Total length" } 



/******************FOOTER******************/
LanguageDatabase["FooterMenu.Trv"] = { swedish: "Trafikverket", english: "Swedish Transport Administration" }
LanguageDatabase["FooterMenu.IdNo"] = { swedish: "Org.nr", english: "Corporate ID No." }


/******************HEADLINES MENU******************/
LanguageDatabase["TitleMenu.ConnectedNetworks"] = { swedish: "Angränsande större infrakstrukturförvaltare", english: "Connected major railway networks" }
LanguageDatabase["TitleMenu.ATCETC"] = { swedish: "ATC, ETCS", english: "ATC, ETCS" }
LanguageDatabase["TitleMenu.Lines"] = { swedish: "Bandelar", english: "Lines" }
LanguageDatabase["TitleMenu.Yards"] = { swedish: "Bangårdar", english: "Railway yards" }
LanguageDatabase["TitleMenu.Detectors"] = { swedish: "Detektorer", english: "Detectors" }
LanguageDatabase["TitleMenu.ElectrifiedLine"] = { swedish: "Elektrifierad bana", english: "Electrified line" }
LanguageDatabase["TitleMenu.Codification"] = { swedish: "Kodifiering", english:  "Codification" }
LanguageDatabase["TitleMenu.Communicationsystem"] = { swedish: "Kommunikationssystem, GSM-R", english: "Communicationsystem, GSM-R" }
LanguageDatabase["TitleMenu.LineCategory"] = { swedish: "Linjekategori", english: "Line category" }
LanguageDatabase["TitleMenu.OperationalPoints"] = { swedish: "Platser", english: "Operational points" }
LanguageDatabase["TitleMenu.Tracks"] = { swedish: "Spårtyper", english: "Type of tracks" }
LanguageDatabase["TitleMenu.Conditions"] = { swedish: "Särskilda förutsättningar", english: "Special conditions" }
LanguageDatabase["TitleMenu.TrafficSystem"] = { swedish: "Trafikeringssystem", english: "Traffic control system" }
LanguageDatabase["TitleMenu.OpPoint"] = { swedish: "Trafikplatser", english: "Operational point characteristics" }







export enum Language {
  SV,
  ENG
}

interface LanguageObject {
  swedish: string;
  english: string;
}